const excludedAuthPaths = [
  '/login',
  '/logout',
  '/otp/login',
  '/otp/redirect',
  '/register',
  '/reset-password',
  'welcome'
]

export default defineNuxtRouteMiddleware(async (_to: any, _from: any) => {
  const userStore = useUserStore()
  const { isLoggedIn, isLoggedInAsContact } = userStore

  if (isLoggedIn || isLoggedInAsContact) {
    const isActive = await userStore.checkStatus()
    if (!isActive) {
      userStore.logout()
      return navigateTo('/welcome')
    }
  }

  if (isLoggedIn) {
    await useUserSettingsStore().fetchUserSettings()
  } else if (!excludedAuthPaths.some((path) => _to.path.includes(path)) && !isLoggedInAsContact) {
    return navigateTo('/welcome')
  }
})
